const WALLET_CONVERSIONS_TABLE_HEADERS = [
  { name: 'Conversion ID', column: 'conversion_id' },
  { name: 'From', column: 'from_display' },
  { name: 'To', column: 'to_display' },
  { name: 'Rate', column: 'rate_line' },
  { name: 'Date', column: 'created_at', filter: 'date' },
  { name: 'Status', column: 'status_display' }
];

const WALLET_CONVERSIONS_STATUSES = [
  { value: 'COMPLETE', label: 'Complete' },
  { value: 'PROCESSING', label: 'Processing' },
  { value: 'FAILED', label: 'Failed' }
];

export { WALLET_CONVERSIONS_STATUSES, WALLET_CONVERSIONS_TABLE_HEADERS };
